export enum ValidationType {
  REQUIRED = 'required',
  PATTERN = 'pattern',
}
